





import { Vue, Component } from 'vue-property-decorator'

@Component({
  name: 'WingBlank'
})
export default class WingBlank extends Vue {

}
